package com.iregained.site.utils

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

// NEW COMPOSABLE: Visually formats the email inline
@Composable
fun ObfuscatedEmailText(email: String, modifier: Modifier = Modifier) {
    val parts = email.split("@")

    Span(attrs = modifier.toAttrs()) {
        if (parts.size == 2) {
            val user = parts[0]
            val domainParts = parts[1].split(".")

            Text(user)

            // THE TRAP: Invisible to humans, but bots read the raw text
            Span(attrs = Modifier.display(DisplayStyle.None).toAttrs()) {
                Text("-nospam-")
            }

            Text("@")
            Text(domainParts[0])

            if (domainParts.size > 1) {
                // THE TRAP: Second layer
                Span(attrs = Modifier.display(DisplayStyle.None).toAttrs()) {
                    Text("-nospam-")
                }

                Text(".")
                Text(domainParts[1])
            }
        } else {
            Text(email) // Safety fallback
        }
    }
}